/**
 * Cart Upsell – Native Horizon Theme Implementation
 */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('.cart-upsell__add');
  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId || button.dataset.variant;
  if (!variantId || button.disabled) return;

  button.disabled = true;
  button.classList.add('is-loading');

  try {
    // 1️⃣ Add the item to the cart
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!addRes.ok) throw new Error('Add failed');

    // 2️⃣ Fetch the updated full cart state (Required by Horizon)
    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();

    // 3️⃣ Tap into Horizon's internal event module
    try {
      const { CartUpdateEvent } = await import('@theme/events');
      
      // Dispatch Horizon's strictly typed cart event
      const cartEvent = new CartUpdateEvent(cartData, 'manual-trigger', { 
        itemCount: cartData.item_count, 
        source: 'upsell-refresh', 
        sections: {} 
      });
      document.dispatchEvent(cartEvent);

      // 4️⃣ Target Horizon's native Web Component to open the drawer
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        cartDrawer.open();
      }
    } catch (themeErr) {
      console.warn('[CartUpsell] Horizon theme hooks failed or not found.', themeErr);
      // Optional fallback: window.location.reload();
    }

    // Optional UX
    button.textContent = 'Added';
    button.classList.remove('is-loading');
    button.classList.add('is-added');

  } catch (err) {
    console.error('[CartUpsell] Add failed', err);
    button.disabled = false;
    button.classList.remove('is-loading');
  }
});

